import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IRoleWarehouseFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		roleId?: any;
		warehouseId?: any;
}

export class RoleWarehouseFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public roleId: IEntityModelField = { name: "roleId", displayName: "Role Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public warehouseId: IEntityModelField = { name: "warehouseId", displayName: "Warehouse Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.roleId);
		this.push(this.warehouseId);
	}
}

export class RoleWarehouseDTO implements IEntityModel {
	protected roleWarehouseName: string = "RoleWarehouseModel";
	protected roleWarehouseKeyField: string = "id";
	protected roleWarehouseDisplayName: string = "Role Warehouse|Role Warehouses";
	protected roleWarehouseFields = new RoleWarehouseFields();
	public get name(): string { return this.roleWarehouseName };
	public get keyField(): string { return this.roleWarehouseKeyField };
	public get displayName(): string { return this.roleWarehouseDisplayName };
	public get fields(): RoleWarehouseFields { return this.roleWarehouseFields };

	constructor() {};
}
